const getPatientOrders = (state) => {
  return state.patientOrders;
};

export default {
  getPatientOrders
};
